/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Operation } from '../../models/operation';
import { UserInfoDto } from '../../models/user-info-dto';

export interface PatchUser$Params {
  id: number;
  'X-API-Version'?: string;
      body: Array<Operation>
}

export function patchUser(http: HttpClient, rootUrl: string, params: PatchUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInfoDto>> {
  const rb = new RequestBuilder(rootUrl, patchUser.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserInfoDto>;
    })
  );
}

patchUser.PATH = '/api/users/{id}';
